import React from "react"

class PreviewPopoverProduct extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var actions = []
    for (var i = 0, ilen = this.props.product.actions.length; i < ilen; i++) {
      var action = this.props.product.actions[i];
      actions.push( <a key={i} href={`${action.path}`} className='btn btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>{I18n.t(action.name)}</a>)
      // actions += "<a href='" + action.path + "' class='btn btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>" + I18n.t(action.name) + "</a>";
    }

    return(
      <div className="popover-preview">
        <div className="popover-close-wrapper">
          <button type="button" className="close" onClick={$(this).parents('.popover').popover('hide')}><span aria-hidden="true">x</span><span className="sr-only">Close</span></button>
        </div>
        <div className="popover-heading">
          <h3><div className="model-card"><span className="ss-star">&nbsp;</span></div>{this.props.product.name} </h3>
        </div>
        <div className="popover-body">
          <div className="row">
            <div className="col-xs-6">
              <label>{I18n.t('product_type')}</label>
              <div className="value">{`${I18n.t(`${this.props.product.product_type}`)}`}</div>
            </div>
            <div className="col-xs-6">
              <label>{I18n.t('description')}</label>
              <div className="value">{this.props.product.description}</div>
            </div>
          </div>


          <hr style={{ margin: '5px 0 10px 0' }} />
          <div className="quick-links">{actions}</div>
        </div>

      </div>

    )
  }
}

export default PreviewPopoverProduct